
export default {
    SET_PAYMENT_TYPES:  (state, paymentTypes) => {
        state.paymentTypes = paymentTypes;
    },
}